export const SET_SHIFTS = 'SET_SHIFTS';
